"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME = exports.VERTICAL_ORIENTATION_PHOTO = exports.TRIPLE_RIGHT_VERTICAL_STRATEGY_META = exports.TRIPLE_LEFT_VERTICAL_STRATEGY_META = exports.STRATEGIES_RENDERING_GROUPS = exports.STRATEGIES_META = exports.SINGLE_HORIZONTAL_STRATEGY_META = exports.HORIZONTAL_ORIENTATION_PHOTO = exports.DOUBLE_VERTICAL_STRATEGY_META = exports.DOUBLE_HORIZONTAL_STRATEGY_META = exports.CATEGORIES_PHOTOS_BLOCK_ID = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HORIZONTAL_ORIENTATION_PHOTO = exports.HORIZONTAL_ORIENTATION_PHOTO = 'horizontal';
var VERTICAL_ORIENTATION_PHOTO = exports.VERTICAL_ORIENTATION_PHOTO = 'vertical';
var SINGLE_HORIZONTAL_STRATEGY_META = exports.SINGLE_HORIZONTAL_STRATEGY_META = {
  INDEX: 0,
  SIZE: 1,
  ORIENTATIONS: [HORIZONTAL_ORIENTATION_PHOTO]
};
var DOUBLE_HORIZONTAL_STRATEGY_META = exports.DOUBLE_HORIZONTAL_STRATEGY_META = {
  INDEX: 1,
  SIZE: 2,
  ORIENTATIONS: [HORIZONTAL_ORIENTATION_PHOTO, HORIZONTAL_ORIENTATION_PHOTO]
};
var TRIPLE_LEFT_VERTICAL_STRATEGY_META = exports.TRIPLE_LEFT_VERTICAL_STRATEGY_META = {
  INDEX: 2,
  SIZE: 3,
  ORIENTATIONS: [VERTICAL_ORIENTATION_PHOTO, HORIZONTAL_ORIENTATION_PHOTO, HORIZONTAL_ORIENTATION_PHOTO]
};
var TRIPLE_RIGHT_VERTICAL_STRATEGY_META = exports.TRIPLE_RIGHT_VERTICAL_STRATEGY_META = {
  INDEX: 3,
  SIZE: 3,
  ORIENTATIONS: [HORIZONTAL_ORIENTATION_PHOTO, HORIZONTAL_ORIENTATION_PHOTO, VERTICAL_ORIENTATION_PHOTO]
};
var DOUBLE_VERTICAL_STRATEGY_META = exports.DOUBLE_VERTICAL_STRATEGY_META = {
  INDEX: 4,
  SIZE: 2,
  ORIENTATIONS: [VERTICAL_ORIENTATION_PHOTO, VERTICAL_ORIENTATION_PHOTO]
};
var STRATEGIES_META = exports.STRATEGIES_META = [SINGLE_HORIZONTAL_STRATEGY_META, DOUBLE_HORIZONTAL_STRATEGY_META, TRIPLE_LEFT_VERTICAL_STRATEGY_META, TRIPLE_RIGHT_VERTICAL_STRATEGY_META, DOUBLE_VERTICAL_STRATEGY_META];
var STRATEGIES_RENDERING_GROUPS = exports.STRATEGIES_RENDERING_GROUPS = [function (_ref, _onClick) {
  var _ref2 = _slicedToArray(_ref, 1),
    horizontalPhoto = _ref2[0];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.itemWrapper,
    key: horizontalPhoto
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.item,
    style: {
      backgroundImage: "url(\"".concat(horizontalPhoto, "\")")
    },
    onClick: function onClick() {
      return _onClick(horizontalPhoto);
    }
  }));
}, function (horizontalPhotos, _onClick2) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.itemWrapper, _styles.default.multiple),
    key: horizontalPhotos.join('')
  }, R.map(function (horizontalPhoto) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.item,
      key: horizontalPhoto,
      style: {
        backgroundImage: "url(\"".concat(horizontalPhoto, "\")")
      },
      onClick: function onClick() {
        return _onClick2(horizontalPhoto);
      }
    });
  }, R.filter(Boolean, horizontalPhotos)));
}, function (_ref3, _onClick3) {
  var _ref4 = _toArray(_ref3),
    verticalPhoto = _ref4[0],
    horizontalPhotos = _ref4.slice(1);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.itemWrapper, _styles.default.multiple, _styles.default.hasVertical),
    key: [verticalPhoto].concat(_toConsumableArray(horizontalPhotos)).join('')
  }, verticalPhoto && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.item,
    style: {
      backgroundImage: "url(\"".concat(verticalPhoto, "\")")
    },
    onClick: function onClick() {
      return _onClick3(verticalPhoto);
    }
  }), R.map(function (horizontalPhoto) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.item,
      key: horizontalPhoto,
      style: {
        backgroundImage: "url(\"".concat(horizontalPhoto, "\")")
      },
      onClick: function onClick() {
        return _onClick3(horizontalPhoto);
      }
    });
  }, R.filter(Boolean, horizontalPhotos)));
}, function (_ref5, _onClick4) {
  var _ref6 = _slicedToArray(_ref5, 3),
    horizontalPhotoA = _ref6[0],
    horizontalPhotoB = _ref6[1],
    verticalPhoto = _ref6[2];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.itemWrapper, _styles.default.multiple, _styles.default.hasVertical),
    key: [horizontalPhotoA, horizontalPhotoB, verticalPhoto].join('')
  }, R.map(function (horizontalPhoto) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.item,
      key: horizontalPhoto,
      style: {
        backgroundImage: "url(\"".concat(horizontalPhoto, "\")")
      },
      onClick: function onClick() {
        return _onClick4(horizontalPhoto);
      }
    });
  }, R.filter(Boolean, [horizontalPhotoA, horizontalPhotoB])), verticalPhoto && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.item,
    style: {
      backgroundImage: "url(\"".concat(verticalPhoto, "\")")
    },
    onClick: function onClick() {
      return _onClick4(verticalPhoto);
    }
  }));
}, function (verticalPhotos, _onClick5) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.itemWrapper, _styles.default.hasVertical),
    key: verticalPhotos.join('')
  }, R.map(function (verticalPhoto) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.item,
      key: verticalPhoto,
      style: {
        backgroundImage: "url(\"".concat(verticalPhoto, "\")")
      },
      onClick: function onClick() {
        return _onClick5(verticalPhoto);
      }
    });
  }, R.filter(Boolean, verticalPhotos)));
}];
var WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME = exports.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME = {
  id: 1e5,
  name: 'WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME'
};
var CATEGORIES_PHOTOS_BLOCK_ID = exports.CATEGORIES_PHOTOS_BLOCK_ID = 'CATEGORIES_PHOTOS_BLOCK_ID';